import { Inject, Injectable } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import {
  Event,
  GiftCard,
  Land,
  LikeCollection,
  Post,
  Sharry,
  SharryContent,
  User,
  UserRole,
  Wonder,
} from 'src/types/graphql';

@Injectable({ providedIn: 'root' })
export class ContentTypeColorizerService {
  constructor(@Inject(I18NEXT_SERVICE) private translateService: ITranslationService) {}

  colorize(
    value: Partial<Sharry | Wonder | Event | LikeCollection | User | Post | GiftCard | Land>,
    type: 'short' | 'long' = 'long',
  ): {
    color: string;
    text: string;
  } {
    let color;
    let icon;
    let extra;
    switch ((value as SharryContent).contentType || value.__typename?.toLowerCase()) {
      case 'wonder':
        color = '#63921a';
        if (type === 'long') {
          if (!(value as Wonder).isRecommendation && !!(value as Wonder).sharryKind?.name) {
            icon = this.translateService.t('wonder');
            extra = '&nbsp;}&nbsp;&nbsp;' + this.translateService.t((value as Wonder).sharryKind?.name);
          } else {
            color = '#AFAFAF';
            icon = this.translateService.t('recommendation');
            break;
          }
        } else {
          if (!(value as Wonder).isRecommendation && !!(value as Wonder).sharryKind?.name) {
            icon = this.translateService.t((value as Wonder).sharryKind?.name);
          } else {
            color = '#AFAFAF';
            icon = this.translateService.t('recommendation');
            break;
          }
        }
        break;
      case 'sharry':
        color = (value as Sharry).soldBySharryland ? '#c79315' : '#a9196a';
        if (type === 'long') {
          icon = this.translateService.t('sharry');
          if ((value as Sharry).sharryKind?.name) {
            extra = '&nbsp;}&nbsp;&nbsp;' + this.translateService.t((value as Sharry).sharryKind?.name);
          }
        } else {
          if ((value as Sharry).sharryKind?.name) {
            icon = this.translateService.t((value as Sharry).sharryKind?.name);
          } else {
            icon = this.translateService.t('sharry');
          }
        }
        break;
      case 'user':
        if ((value as User).qualification?.text) {
          if (type === 'long') {
            color = (value as User).sharrylandPartner
              ? '#c79315'
              : (value as User).role === UserRole.TrustedUser
                ? '#dd407f'
                : '#7e7e7e';
            icon = this.translateService.t('user') + ((value as User).isSmallOrganisation ? ' PRO' : '');
            extra = '&nbsp;}&nbsp;&nbsp;' + this.translateService.t((value as User).qualification?.text);
          } else {
            color = (value as User).sharrylandPartner
              ? '#c79315'
              : (value as User).role === UserRole.TrustedUser
                ? '#dd407f'
                : '#7e7e7e';
            icon = this.translateService.t((value as User).qualification?.text);
          }
        }
        break;
      case 'event':
        color = '#0A75C2';
        if (type === 'long') {
          icon = this.translateService.t('event');
          if ((value as Event).sharryKind?.name) {
            extra = '&nbsp;}&nbsp;&nbsp;' + this.translateService.t((value as Event).sharryKind?.name);
          }
        } else {
          if ((value as Event).sharryKind?.name) {
            icon = this.translateService.t((value as Event).sharryKind?.name);
          } else {
            icon = this.translateService.t('event');
          }
        }
        break;
      case 'land':
        color = '#B2563C';
        icon = this.translateService.t('land');
        break;
      case 'likecollection':
      case 'LikeCollection':
        color = '#a9196a';
        icon = this.translateService.t('likecollection');
        break;
      case 'post':
        color = '#4527a0';
        icon = this.translateService.t(value.__typename.toLowerCase());
        break;
      case 'giftcard':
        color = '#a9196a';
        icon = this.translateService.t('colorize.product');
        break;
      default:
        color = '#222';
        icon = '';
        break;
    }
    return { color, text: `${icon}${extra ? ' ' + extra : ''}` };
  }
}
